export default __webpack_public_path__ + "static/media/blueCircle.d610e24b.svg";